import React from 'react';
import _ from 'underscore';

import { Helpers } from '../../../ts/helpers/Helpers';
import { postLoginNotification } from '../../../zeus/PostLoginNotification';
import { useIsMounted } from '../../hooks';
import { ServiceLocator } from '../../ServiceLocator';
import { UrlParamKeys } from '../../UrlParamKeys';

export const ProcessAndRemoveSamlQueryWrapper: React.FunctionComponent<{}> = props => {
  const isMounted = useIsMounted();
  if (!isMounted) {
    const $location = ServiceLocator.get<ng.ILocationService>('$location');
    const search = $location.search();
    if (_.has(search, UrlParamKeys.IsFromSaml)) {
      if (Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.IsFromSaml])) {
        if (postLoginNotification) {
          postLoginNotification.enableNotifications();
        }
      }
      $location.search(UrlParamKeys.IsFromSaml, null);
    }
  }

  return <>{props.children}</>;
};
